module.exports = __webpack_public_path__ + "img/ring_r_s_null_0@2x.da02f9de.png";